define("ember-cli-clipboard/components/copy-button", ["exports", "@ember/component", "@glimmer/component", "@ember/object/internals", "ember-arg-types", "prop-types", "@ember/template-factory"], function (_exports, _component, _component2, _internals, _emberArgTypes, _propTypes, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/object/internals",0,"ember-arg-types",0,"prop-types",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <button
    class='copy-btn'
    type={{this.buttonType}}
    data-clipboard-id={{this.guid}}
    ...attributes
    {{clipboard
      text=this.text
      target=this.target
      action=this.action
      delegateClickEvent=this.delegateClickEvent
      container=this.container
      onError=this.onError
      onSuccess=this.onSuccess
    }}
  >
    {{yield}}
  </button>
  */
  {
    "id": "A3kMFDBj",
    "block": "[[[11,\"button\"],[24,0,\"copy-btn\"],[16,4,[30,0,[\"buttonType\"]]],[16,\"data-clipboard-id\",[30,0,[\"guid\"]]],[17,1],[4,[38,0],null,[[\"text\",\"target\",\"action\",\"delegateClickEvent\",\"container\",\"onError\",\"onSuccess\"],[[30,0,[\"text\"]],[30,0,[\"target\"]],[30,0,[\"action\"]],[30,0,[\"delegateClickEvent\"]],[30,0,[\"container\"]],[30,0,[\"onError\"]],[30,0,[\"onSuccess\"]]]]],[12],[1,\"\\n  \"],[18,2,null],[1,\"\\n\"],[13]],[\"&attrs\",\"&default\"],false,[\"clipboard\",\"yield\"]]",
    "moduleName": "ember-cli-clipboard/components/copy-button.hbs",
    "isStrictMode": false
  });
  // eslint-disable-next-line ember/no-classic-components
  let CopyButtonComponent = _exports.default = (_dec = (0, _emberArgTypes.arg)((0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func])), _dec2 = (0, _emberArgTypes.arg)((0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func])), _dec3 = (0, _emberArgTypes.arg)((0, _propTypes.oneOf)(['copy', 'cut'])), _dec4 = (0, _emberArgTypes.arg)(_propTypes.boolean), _dec5 = (0, _emberArgTypes.arg)((0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element])), _dec6 = (0, _emberArgTypes.arg)(_propTypes.string), _dec7 = (0, _emberArgTypes.arg)(_propTypes.boolean), _dec8 = (0, _emberArgTypes.arg)(_propTypes.boolean), (0, _emberArgTypes.forbidExtraArgs)(_class = (_class2 = class CopyButtonComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "guid", (0, _internals.guidFor)(this));
      _initializerDefineProperty(this, "text", _descriptor, this);
      _initializerDefineProperty(this, "target", _descriptor2, this);
      _initializerDefineProperty(this, "action", _descriptor3, this);
      _initializerDefineProperty(this, "delegateClickEvent", _descriptor4, this);
      _initializerDefineProperty(this, "container", _descriptor5, this);
      _initializerDefineProperty(this, "buttonType", _descriptor6, this);
      _initializerDefineProperty(this, "onError", _descriptor7, this);
      _initializerDefineProperty(this, "onSuccess", _descriptor8, this);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "text", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "target", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "action", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "delegateClickEvent", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "container", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "buttonType", [_dec6], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 'button';
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "onError", [_dec7], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "onSuccess", [_dec8], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class2)) || _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CopyButtonComponent);
});